import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/rootReducerType';

interface RenterNotificationGate {
  flagEnabled: boolean;
  propertyEnabled: boolean;
  isEnabled: boolean;
  loading: boolean;
}

export const useRenterNotificationGateV2 = (): RenterNotificationGate => {
  const flagEnabled = useSelector((state: RootState) =>
    Boolean(state.featureFlags.flags?.HOUSEHOLD_NOTIFICATIONS_ENABLED)
  );

  const certificationsLoaded = useSelector(
    (state: RootState) => state.newRenterInterface.certificationsLoaded
  );

  const propertyEnabled = useSelector((state: RootState) =>
    state.newRenterInterface.certifications.some(
      (cert) => cert.property?.enable_renter_notifications === true
    )
  );

  const isEnabled = flagEnabled && propertyEnabled;

  return {
    flagEnabled,
    propertyEnabled,
    isEnabled,
    loading: !certificationsLoaded,
  };
};
